__webpack_require__.p = "https://images-cdn.curipod.com/d-88c1a94f/_next/";